import { Component, OnInit, ChangeDetectorRef, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Store } from '@ngrx/store';

import * as fromRoot from './store/reducers';
import { AppUiActions } from './store/actions';
import { TestTakerService } from './services/test-taker.service';
import { TestContentService } from './services/test-content.service';
import * as Enum from './dtos/enums';
import { MyModal } from "./components/common/my-modal/my-modal.component";
import { SignalRService } from './services/signalR.service';
import { ConfigHelper } from './services/config.helper';
import { FromEventObservable } from 'rxjs/observable/FromEventObservable';

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Component({
    selector: 'app',
    template: require('./app.component.html')
})
export class AppComponent implements OnInit {
    loading$: Observable<boolean>;
    isPauseScreenVisible$: Observable<boolean>;
    isExitScreenVisible$: Observable<boolean>;
    isLockScreenVisible$: Observable<boolean>;

    constructor(
        private store: Store<fromRoot.State>,
        private changeDetectorRef: ChangeDetectorRef,
        private testTakerService: TestTakerService,
        private testContentService: TestContentService,
        private vcRef: ViewContainerRef,
        private myModal: MyModal,
        private signalRService: SignalRService
    ) {
        myModal.setRootViewContainerRef(vcRef);
    }

    ngOnInit() {
        this.loading$ = this.store.select(fromRoot.getIsLoading);
        this.isPauseScreenVisible$ = this.store.select(fromRoot.getIsPauseScreenVisible);
        this.isExitScreenVisible$ = this.store.select(fromRoot.getIsExitScreenVisible);
        this.isLockScreenVisible$ = this.store.select(fromRoot.getIsLockScreenVisible);
        this.bindHotKeys();
        this.bindTabClickEvent();

        if (ConfigHelper.isTdpMode(true)) {
            // disable context menu
            window.addEventListener("contextmenu", function (e) {
                e.preventDefault();
            }, false);
        }
    }

    bindTabClickEvent() {
        $(document).on("click", ".testlet-tab-header", (e: JQueryEventObject) => {
            if (ConfigHelper.isTdpMode()) {
                this.testTakerService.cacheTestTakerActivity(Enum.TestTakerActivityTypeEnum.TabClick, null, e.target.textContent, this.testContentService.activeTestletId);
            }
            $('.pane-content').scrollTop(0);
        });
    }

    bindHotKeys() {
        $(document).keydown((event: JQueryKeyEventObject) => {
            if (ConfigHelper.isTdpMode(true)) {
                const forbiddenShortcuts = [
                    event.keyCode === 116, //f5
                    event.keyCode === 117, //f6
                    event.keyCode === 122, //f11
                    event.keyCode === 123, //f12
                    event.altKey && event.keyCode === 115, //alt+f4 !
                    event.ctrlKey && event.keyCode === 48, //ctrl+0
                    event.ctrlKey && event.keyCode === 49, //ctrl+1
                    event.ctrlKey && event.keyCode === 50, //ctrl+2
                    event.ctrlKey && event.keyCode === 51, //ctrl+3
                    event.ctrlKey && event.keyCode === 52, //ctrl+4
                    event.ctrlKey && event.keyCode === 53, //ctrl+5
                    event.ctrlKey && event.keyCode === 54, //ctrl+6
                    event.ctrlKey && event.keyCode === 55, //ctrl+7
                    event.ctrlKey && event.keyCode === 56, //ctrl+8
                    event.ctrlKey && event.keyCode === 57, //ctrl+9
                    event.ctrlKey && event.keyCode === 72, //ctrl+H
                    event.ctrlKey && event.keyCode === 78, //ctrl+N !
                    event.ctrlKey && event.keyCode === 78, //ctrl+O
                    event.ctrlKey && event.keyCode === 82, //ctrl+R
                    event.ctrlKey && event.keyCode === 83, //ctrl+S
                    event.ctrlKey && event.keyCode === 84, //ctrl+T !
                    event.ctrlKey && event.keyCode === 87, //ctrl+W !
                ];

                if (forbiddenShortcuts.indexOf(true) >= 0) {
                    event.preventDefault();
                    event.stopPropagation();
                    return;
                }
            }

            if (event.altKey && ConfigHelper.isTdpMode(false)) {
                if (event.keyCode === 115) {
                    // alt + f4
                    this.store.dispatch(new AppUiActions.ShowExitScreen());
                    this.changeDetectorRef.detectChanges();
                } else if (event.keyCode === 118) {
                    // alt + f7
                    this.store.dispatch(new AppUiActions.ShowLockScreen());
                    this.testTakerService.saveTestTakerActivityWithoutCaching(Enum.TestTakerActivityTypeEnum.ScreenLockStart);
                    this.changeDetectorRef.detectChanges();
                }
            }

            if (_paragonConfig.shortcutsEnabled === true) {
                if (event.keyCode === 114) {
                    // f3
                } else if (event.keyCode === 115) {
                    // f4
                    this.store.dispatch(new AppUiActions.ToggleNavigationModal(true));
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/app.component.ts